import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeroCarousel from '../components/HeroCarousel';
import HomeStatsSection from '../components/HomeStatsSection';
import FeaturedGallery from '../components/FeaturedGallery';
import LatestBlogs from '../components/LatestBlogs';
import './Home.css';

const eventStartDate = new Date('2026-08-30T00:00:00+05:30').getTime();

const getCountdown = () => {
  const distance = Math.max(eventStartDate - Date.now(), 0);

  return {
    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
    hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((distance / (1000 * 60)) % 60),
    seconds: Math.floor((distance / 1000) % 60)
  };
};

const Home = () => {
  const [countdown, setCountdown] = useState(getCountdown);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(getCountdown());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <>
      <HeroCarousel />

      <section className="home-showcase-countdown">
        <div className="container">
          <div className="home-showcase-card">
            <div className="home-showcase-image">
              <img src="/img/august_2026.jpeg" alt="SSVASS Jewellery Mahotsav August 2026" />
            </div>
            <div className="home-showcase-copy">
              <span className="home-eyebrow">Upcoming Show</span>
              <h2>30 Aug - 01 Sep 2026, Patna</h2>
              <p className="home-showcase-edition">21st Edition at Gyan Bhawan Convention Centre</p>
              <div className="home-countdown" aria-label="Countdown to 30 August 2026">
                <div>
                  <strong>{countdown.days}</strong>
                  <span>Days</span>
                </div>
                <div>
                  <strong>{String(countdown.hours).padStart(2, '0')}</strong>
                  <span>Hours</span>
                </div>
                <div>
                  <strong>{String(countdown.minutes).padStart(2, '0')}</strong>
                  <span>Minutes</span>
                </div>
                <div>
                  <strong>{String(countdown.seconds).padStart(2, '0')}</strong>
                  <span>Seconds</span>
                </div>
              </div>
              <div className="home-2027-shows">
                <h3>Patna 2027 Show Calendar</h3>
                <div>
                  <span>11, 12 & 13 April</span>
                  <strong>Pioneers - 22nd Edition</strong>
                </div>
                <div>
                  <span>12, 13 & 14 September</span>
                  <strong>Patna - 23rd Edition</strong>
                </div>
                <div>
                  <span>18, 19 & 20 December</span>
                  <strong>Varanasi - 24th Edition</strong>
                </div>
              </div>
              <div className="home-event-actions">
                <Link to="/stall" className="home-btn home-btn-primary">Book a Stall</Link>
                <Link to="/visitor" className="home-btn home-btn-outline">Visitor Registration</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-event-strip">
        <div className="container">
          <div className="home-event-card">
            <div className="home-event-copy">
              <span className="home-eyebrow">National Gems & Jewellery Exhibition</span>
              <p className="home-event-kicker">21st Edition - SSVASS Gems & Jewellery Exhibition 2026</p>
              <h1>SSVASS Jewellery Mahotsav 2026</h1>
              <p>
                The 21st edition brings jewellers, exhibitors, hosted buyers, and trade visitors together for three
                focused days of networking, discovery, and business growth in Patna.
              </p>
              <div className="home-event-theme">
                <span>Theme</span>
                <strong>"Connecting Craftsmanship, Innovation & Business Excellence"</strong>
              </div>
              <div className="home-event-content-grid">
                <div>
                  <h3>Highlights</h3>
                  <ul>
                    <li>450+ Exhibitors</li>
                    <li>15,000+ Trade Visitors</li>
                    <li>2,000+ Hosted Buyers</li>
                    <li>Participation from Major Jewellery Manufacturing Hubs</li>
                    <li>Product Launches</li>
                    <li>Business Networking Sessions</li>
                    <li>New Technology Showcase</li>
                    <li>Diamond, Gold, Silver & Bridal Jewellery Collections</li>
                    <li>Machinery & Allied Industry Participation</li>
                  </ul>
                </div>
                <div>
                  <h3>Product Categories</h3>
                  <ul>
                    <li>Gold Jewellery</li>
                    <li>Diamond Jewellery</li>
                    <li>Silver Jewellery</li>
                    <li>Platinum Jewellery</li>
                    <li>Bridal Jewellery</li>
                    <li>Gemstones & Diamonds</li>
                    <li>Luxury Jewellery</li>
                    <li>Fashion Jewellery</li>
                    <li>Jewellery Machinery</li>
                    <li>Packaging Solutions</li>
                    <li>Technology & Services</li>
                  </ul>
                </div>
              </div>
              <div className="home-why-attend">
                <h3>Why Attend?</h3>
                <p>
                  Discover new suppliers, explore latest jewellery trends, network with industry leaders, and unlock
                  unlimited business opportunities at Eastern India's premier gems and jewellery exhibition.
                </p>
              </div>
              <div className="home-event-actions">
                <Link to="/visitor" className="home-btn home-btn-primary">Visitor Registration</Link>
                <Link to="/stall" className="home-btn home-btn-outline">Book a Stall</Link>
              </div>
            </div>
            <div className="home-event-details">
              <h3>Event at a Glance</h3>
              <p>Key details for the 2026 jewellery trade gathering.</p>
              <div>
                <span>Edition</span>
                <strong>21st Edition</strong>
              </div>
              <div>
                <span>Date</span>
                <strong>30 August - 01 September 2026</strong>
              </div>
              <div>
                <span>Venue</span>
                <strong>Gyan Bhavan, Gandhi Maidan, Patna, Bihar</strong>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-about-modern">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5">
              <div className="home-section-label">About SSVASS</div>
              <h2>Focused on the future of gems and jewellery trade.</h2>
            </div>
            <div className="col-lg-7">
              <p>
                SSVASS Enterprises organizes one of the region's key jewellery trade exhibitions, creating a
                trusted platform for jewellers, manufacturers, retailers, distributors, and serious buyers.
                The exhibition is designed around real business conversations, product discovery, and long-term
                industry relationships.
              </p>
            </div>
          </div>

          <div className="home-info-grid">
            <div className="home-info-card">
              <i className="fas fa-gem"></i>
              <h3>Curated Jewellery Showcase</h3>
              <p>Discover collections across gold, diamond, silver, gemstones, bridal jewellery, and trade services.</p>
            </div>
            <div className="home-info-card">
              <i className="fas fa-handshake"></i>
              <h3>Business Networking</h3>
              <p>Meet exhibitors, retailers, suppliers, buyers, and decision makers from the jewellery ecosystem.</p>
            </div>
            <div className="home-info-card">
              <i className="fas fa-map-marker-alt"></i>
              <h3>Prime Patna Venue</h3>
              <p>Hosted at Gyan Bhawan, Gandhi Maidan, Patna with strong accessibility for visitors and exhibitors.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-exhibitor-profile">
        <div className="container">
          <div className="home-exhibitor-card">
            <div className="home-exhibitor-image">
              <img src="/img/exibitor_profile.png" alt="Exhibitor profile categories" />
            </div>
            <div className="home-exhibitor-copy">
              <span className="home-eyebrow">Exhibitor Profile</span>
              <h2>Who can exhibit at SSVASS Jewellery Mahotsav?</h2>
              <p>
                The exhibition welcomes jewellery manufacturers, gemstone and diamond traders, fashion jewellery
                brands, machinery and technology companies, packaging partners, bullion traders, and service providers
                serving the gems and jewellery industry.
              </p>
              <p>
                Exhibitors get a focused B2B platform to present collections, meet qualified visitors, build trade
                relationships, and grow visibility across the regional jewellery market.
              </p>
              <div className="home-exhibitor-points">
                <span>Premium jewellery showcase</span>
                <span>Trade visitor networking</span>
                <span>Brand visibility in Patna</span>
              </div>
              <div className="home-event-actions">
                <Link to="/stall" className="home-btn home-btn-primary">Book Your Stall</Link>
                <Link to="/contact" className="home-btn home-btn-outline">Talk to Team</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-visitor-profile">
        <div className="container">
          <div className="home-exhibitor-card home-visitor-card">
            <div className="home-exhibitor-copy">
              <span className="home-eyebrow">Visitor Profile</span>
              <h2>Meet serious jewellery buyers and trade visitors.</h2>
              <div className="home-visitor-list">
                <div>
                  <h3>Retail Jewellers</h3>
                  <p>Independent and Multi-Store Jewellery Retailers</p>
                </div>
                <div>
                  <h3>Wholesalers & Distributors</h3>
                  <p>Regional and National Jewellery Distributors</p>
                </div>
                <div>
                  <h3>Jewellery Chain Stores</h3>
                  <p>Organized Retail Networks and Franchise Operators</p>
                </div>
                <div>
                  <h3>Importers & Exporters</h3>
                  <p>Domestic and International Trade Buyers</p>
                </div>
                <div>
                  <h3>Designers & Consultants</h3>
                  <p>Jewellery Designers, Merchandisers and Industry Consultants</p>
                </div>
                <div>
                  <h3>Entrepreneurs</h3>
                  <p>New Business Owners and Startups in the Jewellery Sector</p>
                </div>
                <div>
                  <h3>Corporate Buyers</h3>
                  <p>Institutional and Corporate Procurement Professionals</p>
                </div>
                <div>
                  <h3>Industry Professionals</h3>
                  <p>Manufacturers, Traders, Gemologists and Jewellery Experts</p>
                </div>
              </div>
              <div className="home-event-actions">
                <Link to="/visitor" className="home-btn home-btn-primary">Register as Visitor</Link>
                <Link to="/gallery" className="home-btn home-btn-outline">View Gallery</Link>
              </div>
            </div>
            <div className="home-exhibitor-image">
              <img src="/img/visitors_profile.png" alt="Visitor profile categories" />
            </div>
          </div>
        </div>
      </section>

      <section className="home-media-partner">
        <div className="container">
          <div className="home-media-card">
            <div className="home-media-copy">
              <span className="home-eyebrow">Media Partner</span>
              <h2>Collaborate with SSVASS as a media partner.</h2>
              <p>
                SSVASS welcomes collaboration with leading media organizations, jewellery publications, business
                magazines, digital media platforms, television channels, newspapers, and industry influencers.
              </p>
              <p>
                For media partnership opportunities, please contact our marketing team.
              </p>
              <div className="home-event-actions">
                <Link to="/contact" className="home-btn home-btn-primary">Contact Marketing Team</Link>
              </div>
            </div>
            <div className="home-media-benefits">
              <h3>Benefits for Media Partners</h3>
              <ul>
                <li>Exclusive Event Coverage</li>
                <li>Industry Networking Opportunities</li>
                <li>Brand Exposure to Jewellery Businesses</li>
                <li>Access to Industry Leaders</li>
                <li>Content Collaboration Opportunities</li>
                <li>Press Conferences & Product Launch Coverage</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <HomeStatsSection />

      <section className="home-trade-section">
        <div className="container">
          <div className="section-header text-center">
            <p>What We Do</p>
            <h2>A modern trade platform for jewellery businesses</h2>
          </div>
          <div className="home-trade-grid">
            <div className="home-trade-card">
              <span>01</span>
              <h3>Mission</h3>
              <p>
                Build a reliable exhibition platform where jewellery businesses can present their best collections,
                connect with buyers, and expand their market presence.
              </p>
            </div>
            <div className="home-trade-card">
              <span>02</span>
              <h3>Vision</h3>
              <p>
                Strengthen Patna as an important jewellery trade destination through a professional, organized, and
                visitor-friendly exhibition experience.
              </p>
            </div>
            <div className="home-trade-card">
              <span>03</span>
              <h3>Highlights</h3>
              <p>
                Product launches, premium displays, buyer interactions, trade networking, and useful exposure for
                brands serving the gems and jewellery industry.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-leadership-section">
        <div className="container">
          <div className="home-leadership-card">
            <div>
              <span className="home-eyebrow">Leadership</span>
              <h2>Guided by industry experience and local trust.</h2>
            </div>
            <div>
              <p>
                Under the guidance of Mr. Arun Kumar Verma, SSVASS continues to bring structure, credibility, and
                energy to the gems and jewellery exhibition space. The goal is simple: create an event where exhibitors
                and visitors can focus on meaningful business.
              </p>
              <div className="home-leadership-points">
                <span>35+ years industry experience</span>
                <span>Trade-first exhibition planning</span>
                <span>Strong Patna jewellery network</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FeaturedGallery />

      <LatestBlogs />

      <section className="home-final-cta">
        <div className="container">
          <div className="home-final-card">
            <div>
              <span className="home-eyebrow">Registration Open</span>
              <h2>Be part of the 21st Edition in Patna.</h2>
              <p>Register as a visitor or reserve your exhibition stall for 30 Aug to 01 Sep 2026.</p>
            </div>
            <div className="home-event-actions">
              <Link to="/visitor" className="home-btn home-btn-primary">Register Now</Link>
              <Link to="/contact" className="home-btn home-btn-outline">Contact Team</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
